import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from './PageHeader';
import Breadcrumbs from './Breadcrumbs';

export default function Imprint({ t, lang, setLang }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isGerman = lang === 'de';

  const breadcrumbItems = [
    { label: t('breadcrumb_home') || 'Home', path: '/' },
    { label: isGerman ? 'Impressum' : 'Imprint', path: null },
  ];

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100">
      <PageHeader lang={lang} setLang={setLang} t={t} />
      <div className="max-w-4xl mx-auto px-4 py-8">
        <Breadcrumbs items={breadcrumbItems} />

        <div className="mt-8 space-y-8">
          <h1 className="text-3xl font-bold text-white mb-6">
            {isGerman ? 'Impressum' : 'Imprint'}
          </h1>

          <div className="bg-blue-900/20 border border-blue-700/50 rounded-lg p-4 mb-8">
            <p className="text-blue-200 text-sm">
              {isGerman
                ? 'Dies ist ein privates Community-Projekt. Bei Fragen kontaktieren Sie mich gerne direkt.'
                : 'This is a private community project. Feel free to contact me directly with any questions.'}
            </p>
          </div>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-blue-400">
              {isGerman ? 'Betreiber' : 'Operator'}
            </h2>
            <div className="bg-gray-800 rounded-lg p-6 space-y-3">
              <p className="text-gray-300"><strong>Pascal Puschmann</strong></p>
              <p className="text-gray-300">
                <strong>{isGerman ? 'E-Mail' : 'Email'}:</strong>{' '}
                <a href="mailto:clansight@outlook.com" className="text-blue-400 hover:text-blue-300">
                  clansight@outlook.com
                </a>
              </p>
              <p className="text-gray-300">
                <strong>Discord:</strong>{' '}
                <a href="https://discord.gg/WNcXbE8VFP" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300">
                  {isGerman ? 'Server beitreten' : 'Join Server'}
                </a>
              </p>
            </div>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-blue-400">
              {isGerman ? 'Hinweis' : 'Note'}
            </h2>
            <p className="text-gray-300 leading-relaxed">
              {isGerman
                ? 'Clansight ist ein unabhängiges Community-Projekt und steht in keiner Verbindung zu Supercell, Clash of Clans oder Discord.'
                : 'Clansight is an independent community project and is not affiliated with Supercell, Clash of Clans, or Discord.'}
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-blue-400">EU-Streitschlichtung</h2>
            <p className="text-gray-300 leading-relaxed">
              {isGerman
                ? 'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:'
                : 'The European Commission provides a platform for online dispute resolution (ODR):'}{ ' ' }
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300">https://ec.europa.eu/consumers/odr</a>
            </p>
            <p className="text-gray-300 leading-relaxed">
              {isGerman
                ? 'Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.'
                : 'We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.'}
            </p>
          </section>

          <div className="mt-8 pt-8 border-t border-gray-700">
            <p className="text-sm text-gray-400">Stand: Juni 2026</p>
          </div>
        </div>
      </div>
    </div>
  );
}
